import MapManager from './MapManager.js';

// Navigazione live con geolocalizzazione su una mappa gestita da MapManager
export default class MapNavigator {

    constructor(mapManager) {

        if (!mapManager || !(mapManager instanceof MapManager)) {
            throw new Error("Devi passare una istanza valida di MapManager");
        }

        this.mapManager = mapManager;
        this.map = mapManager.map;
        this.percorso = [];

        this.userMarker = null;
        this.watchId = null;
        this.previousPosition = null;

    }

    init(percorso) {

        this.stop();

        this.percorso = percorso;
        this.mapManager.initReadOnlyMap(percorso);
        this.map = this.mapManager.map;

    }

    // Avvia il tracciamento GPS continuo con watchPosition
    start() {

        if (!navigator.geolocation) {
            this.mapManager.onError("Geolocalizzazione non supportata dal tuo browser.");
            return;
        }

        this.watchId = navigator.geolocation.watchPosition(
            (position) => this.updatePosition(position),
            (error) => this.mapManager.onError("Errore nella geolocalizzazione: " + error.message),
            { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
        );

    }

    // Aggiorna il marker utente e ruota la freccia secondo la direzione
    updatePosition(position) {

        const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };

        let heading = 0;

        if (this.previousPosition) {
            heading = this.computeHeading(this.previousPosition, pos);
        }

        if (!this.userMarker) {
            this.map.setZoom(16);
            this.map.setCenter(pos);
            this.userMarker = new google.maps.Marker({
                position: pos,
                map: this.map,
                icon: {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 4,
                    fillColor: "#007BFF",
                    fillOpacity: 1,
                    strokeColor: "#fff",
                    strokeWeight: 1,
                    rotation: heading,
                    anchor: new google.maps.Point(0, 2),
                },
                title: "La tua posizione",
            });
        } else {
            this.userMarker.setPosition(pos);
            const icon = this.userMarker.getIcon();
            icon.rotation = heading;
            this.userMarker.setIcon(icon);
        }

        this.previousPosition = pos;

    }

    // Bearing tra due coordinate, per orientare la freccia
    computeHeading(from, to) {

        const toRad = (deg) => (deg * Math.PI) / 180;
        const toDeg = (rad) => (rad * 180) / Math.PI;
        const lat1 = toRad(from.lat);
        const lon1 = toRad(from.lng);
        const lat2 = toRad(to.lat);
        const lon2 = toRad(to.lng);
        const dLon = lon2 - lon1;
        const y = Math.sin(dLon) * Math.cos(lat2);
        const x =
            Math.cos(lat1) * Math.sin(lat2) -
            Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
        const brng = Math.atan2(y, x);

        return (toDeg(brng) + 360) % 360;

    }

    stop() {

        if (this.watchId !== null) {
            navigator.geolocation.clearWatch(this.watchId);
            this.watchId = null;
        }

        if (this.userMarker) {
            this.userMarker.setMap(null);
            this.userMarker = null;
        }

    }

    // Apre Google Maps con il percorso attuale, col travelMode del MapManager
    openInGoogleMaps() {

        if (!this.percorso || this.percorso.length < 2) {
            this.mapManager.onError("Percorso insufficiente per l'apertura in Google Maps.");
            return;
        }

        const origin = `${this.percorso[0].lat},${this.percorso[0].lng}`;
        const destination = `${this.percorso[this.percorso.length - 1].lat},${this.percorso[this.percorso.length - 1].lng}`;

        const waypoints = this.percorso
            .slice(1, -1)
            .map(p => `${p.lat},${p.lng}`)
            .join('|');

        const travelModes = { DRIVING: 'driving', BICYCLING: 'bicycling', WALKING: 'walking', TRANSIT: 'transit' };

        const url = new URL('https://www.google.com/maps/dir/');
        url.searchParams.set('api', '1');
        url.searchParams.set('origin', origin);
        url.searchParams.set('destination', destination);
        if (waypoints) url.searchParams.set('waypoints', waypoints);
        url.searchParams.set('travelmode', travelModes[this.mapManager.travelMode] ?? 'driving');

        window.open(url.toString(), '_blank');

    }

}
